import * as React from "react";
import { useSelector } from "react-redux";

import { FormEngineSelectors, FormEngineViews } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import {
	DefaultFormModelMap,
	DefaultWidgetMap,
	FormModelMap,
	useDocumentPathForInput,
	WidgetMap
} from "@com.mgmtp.a12.formengine/formengine-core/lib/view";
import { ActionContentboxProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/contentbox";

import { ActivityIdContext } from "../../../component/ActivityContext";
import { ComponentContext } from "../../../component/ComponentContext";
import { assertNonNullable } from "../../../utilities/assert";
import { COMPONENT } from "../../../utilities/variables/modulfRuntimeAnnotations";
import { Wiedervorlagenzuweisung } from "../../assignment/components/AssigneePicker";
import { ModulFDataContext } from "../../processFormEngine/components/contexts";

import { getViewHtmlId } from "../sagas";

export function FocusHandlingFormEngine(props: FormEngineViews.FormEngineProps): React.ReactNode {
	return (
		<ActivityIdContext.Provider value={props.activityId}>
			<FormEngineViews.FormEngine {...props} formModelMap={formModelMap} widgetMap={widgetsMap} />
		</ActivityIdContext.Provider>
	);
}

const CustomActionContentbox: React.ComponentType<ActionContentboxProps> = function CustomActionContentbox(props) {
	const activityId = React.useContext(ActivityIdContext);
	return <DefaultWidgetMap.ActionContentbox {...props} id={getViewHtmlId(activityId)} />;
};

const CustomControl: FormModelMap["Control"]["component"] = function CustomControl(props) {
	const activityId = React.useContext(ActivityIdContext);
	assertNonNullable(activityId);

	const models = useSelector(FormEngineSelectors.models(activityId));
	assertNonNullable(models?.formModel);

	const { documentModel } = useSelector(FormEngineSelectors.models(activityId)) ?? {};
	assertNonNullable(documentModel);

	const path = useDocumentPathForInput(props.modelElement.elementPath, documentModel);

	const component = props.modelElement.annotations?.find(it => it.name === COMPONENT)?.value;
	return (
		<ModulFDataContext.Provider value={path}>
			<ComponentContext.Provider value={component}>
				<DefaultFormModelMap.Control.component {...props} />
			</ComponentContext.Provider>
		</ModulFDataContext.Provider>
	);
};

const formModelMap: FormModelMap = {
	...DefaultFormModelMap,
	Control: { ...DefaultFormModelMap.Control, component: CustomControl }
};

const widgetsMap: WidgetMap = {
	...DefaultWidgetMap,
	ActionContentbox: CustomActionContentbox,
	Autocomplete(props) {
		const component = React.useContext(ComponentContext);

		if (component === "Wiedervorlagenzuweisung") {
			return <Wiedervorlagenzuweisung {...props} />;
		}

		return <DefaultWidgetMap.Autocomplete {...props} />;
	}
};
